(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3315],{

/***/ 32970:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkout/confirmar-pago",
      function () {
        return __webpack_require__(70514);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CheckoutPaymentConfirm; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/seo.tsx
var seo = __webpack_require__(39425);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(45680);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js
var useQuery = __webpack_require__(71641);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(73359);
// EXTERNAL MODULE: ./node_modules/@apollo/client/errors/index.js
var errors = __webpack_require__(30990);
// EXTERNAL MODULE: ./src/config/environment.ts
var environment = __webpack_require__(60031);
;// CONCATENATED MODULE: ../../node_modules/@fintoc/fintoc-js/build/module/lib/constants.js
const FINTOC_URL = 'https://js.fintoc.com/v1';
const FINTOC_URL_REGEX = /^https:\/\/js\.fintoc\.com\/v1\/?(\?.*)?$/;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9jb25zdGFudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFDLE1BQU0sVUFBVSxHQUFHLDBCQUEwQixDQUFDO0FBQ3JELE1BQU0sQ0FBQyxNQUFNLGdCQUFnQixHQUFHLDJDQUEyQyxDQUFDIn0=
;// CONCATENATED MODULE: ../../node_modules/@fintoc/fintoc-js/build/module/lib/core.js

const findScript = () => {
    const scripts = document.querySelectorAll(`script[src^="${FINTOC_URL}"]`);
    return Array.from(scripts).find((script) => FINTOC_URL_REGEX.test(script.src)) || null;
};
const injectScript = () => {
    const script = document.createElement('script');
    script.src = FINTOC_URL;
    const headOrBody = document.head || document.body;
    if (!headOrBody) {
        throw new Error('Expected document.head or document.body not to be null.');
    }
    headOrBody.appendChild(script);
    return script;
};
let fintocPromise = null;
/**
 * Gets the Fintoc object. If the Fintoc script isn't loaded,
 * this method loads it before retunring the Fintoc object.
 *
 * @returns The {@link Fintoc} object
 */
const getFintoc = () => {
    if (fintocPromise !== null) {
        return fintocPromise;
    }
    fintocPromise = new Promise((resolve, reject) => {
        if (typeof window === 'undefined') {
            // Imports on server side will get a null
            // Fintoc object instead of failing
            resolve(null);
            return;
        }
        if (window.Fintoc) {
            resolve(window.Fintoc);
            return;
        }
        try {
            let script = findScript();
            if (!script) {
                script = injectScript();
            }
            script.addEventListener('load', () => {
                if (window.Fintoc) {
                    resolve(window.Fintoc);
                }
                else {
                    reject(new Error('Fintoc.js is not available'));
                }
            });
            script.addEventListener('error', () => {
                reject(new Error('Failed to load Fintoc.js'));
            });
        }
        catch (error) {
            reject(error);
        }
    });
    return fintocPromise;
};
//# sourceMappingURL=data:application/json;base64,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
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 4 modules
var useAuth = __webpack_require__(21566);
// EXTERNAL MODULE: ./src/hooks/useFacebookPixel.ts
var useFacebookPixel = __webpack_require__(14931);
// EXTERNAL MODULE: ./src/hooks/useMekiState.tsx + 1 modules
var useMekiState = __webpack_require__(48231);
// EXTERNAL MODULE: ./src/hooks/useOrderState.tsx
var useOrderState = __webpack_require__(778);
// EXTERNAL MODULE: ./src/hooks/usePendingPrescriptions.ts + 1 modules
var usePendingPrescriptions = __webpack_require__(3618);
// EXTERNAL MODULE: ./src/hooks/usePermissions.tsx + 1 modules
var usePermissions = __webpack_require__(18782);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/@apollo/client/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(68921);
;// CONCATENATED MODULE: ./src/queries/checkout/mutations/separateOrderByInsurance.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation SeparateOrderDetailsByInsurance(\n    $params: SeparateOrderDetailsByInsuranceParams\n  ) {\n    separateOrderDetailsByInsurance(params: $params) {\n      deliveryDate\n      deliveryType\n      deliveryCost\n      orderDetails {\n        quantity\n        insurance {\n          unitReimbursement\n          unitCopay\n          unitDeductible\n        }\n        type\n        listPrice\n        product {\n          id\n          name\n          imagesUrl\n          activePrinciple\n          concentration\n          unit\n          prescriptionType\n          quantity\n          format\n          price\n          container\n          containerQuantity\n          laboratory\n          availability {\n            stock\n            statusWithoutStock\n            status\n          }\n          discount {\n            type\n            price\n            listPrice\n          }\n        }\n        price\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var SeparateOrderDetailsByInsurance = function() {
    return (0,lib/* gql */.Ps)(_templateObject());
};

// EXTERNAL MODULE: ./src/queries/checkout/queries/detail.ts
var detail = __webpack_require__(45482);
// EXTERNAL MODULE: ./src/queries/checkout/queries/finalSummary.ts
var finalSummary = __webpack_require__(70041);
// EXTERNAL MODULE: ./src/queries/checkout/queries/paymentMethod.ts
var queries_paymentMethod = __webpack_require__(66003);
// EXTERNAL MODULE: ./src/queries/order/queries/nextOrders.ts
var nextOrders = __webpack_require__(37599);
// EXTERNAL MODULE: ./src/queries/order/queries/getLastOrdersPurchases.tsx
var getLastOrdersPurchases = __webpack_require__(29803);
// EXTERNAL MODULE: ./src/queries/order/queries/previousOrders.ts
var queries_previousOrders = __webpack_require__(65165);
;// CONCATENATED MODULE: ./src/queries/payment/mutations/payOrder.tsx
/*
 * File: payOrder.tsx
 * Project: meki
 * File Created: Monday, 9th November 2020 10:31:19 am
 * Author: Vicente Melin (vicente@inventures.cl)
 * -----
 * Last Modified: Wednesday, 5th October 2022 3:30:13 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function payOrder_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\nmutation ",
        "($params: PayOrderParams!){\n  payOrder(params: $params) {\n    id\n    uuid\n    status\n    orderGroupId\n    address {\n      id\n      name\n      street\n      streetNumber\n      commune\n    }\n  }\n}\n"
    ]);
    payOrder_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var PayOrder = function(name) {
    return (0,lib/* gql */.Ps)(payOrder_templateObject(), name);
};

;// CONCATENATED MODULE: ./src/queries/payment/mutations/payOrderFintoc.tsx

function payOrderFintoc_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation PayOrderFintoc($params: PayOrderFintocParams!) {\n    payOrderFintoc(params: $params) {\n      fintocToken\n      uuid\n      orderGroupId\n    }\n  }\n"
    ]);
    payOrderFintoc_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var PayOrderFintoc = function() {
    return (0,lib/* gql */.Ps)(payOrderFintoc_templateObject());
};

;// CONCATENATED MODULE: ./src/queries/payment/mutations/cancelFintocPayment.tsx
/*
 * File: payOrder.tsx
 * Project: meki
 * File Created: Monday, 9th November 2020 10:31:19 am
 * Author: Vicente Melin (vicente@inventures.cl)
 * -----
 * Last Modified: Wednesday, 5th October 2022 3:30:13 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function cancelFintocPayment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CancelFintocPayment($params: CancelFintocPaymentParams!) {\n    cancelFintocPayment(params: $params) {\n      id\n      deliveryType\n      deliveryCost\n      totalCost\n      mekiCreditsUsed\n      onDemand\n      payments {\n        id\n        status\n        amount\n        paymentMethodType\n      }\n      address {\n        id\n        uuid\n        apartment\n        commune\n        street\n        streetNumber\n        details\n        name\n      }\n      paymentMethod {\n        id\n        uuid\n        type\n        data\n      }\n      status\n      orderGroupId\n      paidAt\n      orderDetails {\n        id\n        quantity\n        price\n        product {\n          id\n          name\n          concentration\n          quantity\n          unit\n          format\n          imagesUrl\n          display\n          price\n          prescriptionType\n          metadata {\n            refrigerated\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    cancelFintocPayment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CancelFintocPayment = function() {
    return (0,lib/* gql */.Ps)(cancelFintocPayment_templateObject());
};

;// CONCATENATED MODULE: ./src/queries/payment/mutations/cancelPayOrderLocal.tsx

function cancelPayOrderLocal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CancelPayOrderLocal($params: CancelPayOrderLocalParams!) {\n    cancelPayOrderLocal(params: $params) {\n      status\n      id\n    }\n  }\n"
    ]);
    cancelPayOrderLocal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CancelPayOrderLocal = function() {
    return (0,lib/* gql */.Ps)(cancelPayOrderLocal_templateObject());
};

;// CONCATENATED MODULE: ./src/queries/payment/mutations/confirmLocalPayment.tsx

function confirmLocalPayment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ConfirmLocalPayment($params: ConfirmLocalPaymentParams!) {\n    confirmLocalPayment(params: $params) {\n      id\n      status\n      orderGroupId\n      uuid\n    }\n  }\n"
    ]);
    confirmLocalPayment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ConfirmLocalPayment = function() {
    return (0,lib/* gql */.Ps)(confirmLocalPayment_templateObject());
};

;// CONCATENATED MODULE: ./src/queries/payment/mutations/declarePayOrder.tsx

function declarePayOrder_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation DeclarePayOrder($params: DeclarePayOrderParams!) {\n    declarePayOrder(params: $params) {\n      id\n      uuid\n      status\n      orderGroupId\n      address {\n        id\n        name\n        street\n        streetNumber\n        commune\n      }\n    }\n  }\n"
    ]);
    declarePayOrder_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var DeclarePayOrder = function() {
    return (0,lib/* gql */.Ps)(declarePayOrder_templateObject());
};

;// CONCATENATED MODULE: ./src/queries/payment/mutations/cancelBancoEstadoPayment.tsx

function cancelBancoEstadoPayment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CancelBancoEstadoPayment($params: CancelBancoEstadoPaymentParams!) {\n    cancelBancoEstadoPayment(params: $params) {\n      id\n      deliveryType\n      deliveryCost\n      totalCost\n      mekiCreditsUsed\n      onDemand\n      payments {\n        id\n        status\n        amount\n        paymentMethodType\n      }\n      address {\n        id\n        uuid\n        apartment\n        commune\n        street\n        streetNumber\n        details\n        name\n      }\n      paymentMethod {\n        id\n        uuid\n        type\n        data\n      }\n      status\n      orderGroupId\n      paidAt\n      orderDetails {\n        id\n        quantity\n        price\n        product {\n          id\n          name\n          concentration\n          quantity\n          unit\n          format\n          imagesUrl\n          display\n          price\n          prescriptionType\n          metadata {\n            refrigerated\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    cancelBancoEstadoPayment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CancelBancoEstadoPayment = function() {
    return (0,lib/* gql */.Ps)(cancelBancoEstadoPayment_templateObject());
};

;// CONCATENATED MODULE: ./src/queries/payment/mutations/bancoEstadoPayment.tsx

function bancoEstadoPayment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation BancoEstadoPayment($params: BancoEstadoPaymentParams!) {\n    bancoEstadoPayment(params: $params) {\n      urlCompraqui\n      uuid\n      orderGroupId\n    }\n  }\n"
    ]);
    bancoEstadoPayment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var BancoEstadoPayment = function() {
    return (0,lib/* gql */.Ps)(bancoEstadoPayment_templateObject());
};

;// CONCATENATED MODULE: ./src/queries/payment/mutations/verifyBancoEstadoJwt.tsx

function verifyBancoEstadoJwt_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation VerifyBancoEstadoJwt($params: VerifyBancoEstadoJwtParams!) {\n    verifyBancoEstadoJwt(params: $params) {\n      uuid\n      orders {\n        id\n        uuid\n        status\n        orderGroupId\n        address {\n          id\n          name\n          street\n          streetNumber\n          commune\n        }\n      }\n      totalPrice\n      deliveryPrice\n    }\n  }\n"
    ]);
    verifyBancoEstadoJwt_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var VerifyBancoEstadoJwt = function() {
    return (0,lib/* gql */.Ps)(verifyBancoEstadoJwt_templateObject());
};

// EXTERNAL MODULE: ./src/queries/user/queries/currentUserCredits.tsx
var currentUserCredits = __webpack_require__(93231);
// EXTERNAL MODULE: ./src/services/openreplay.ts
var openreplay = __webpack_require__(92268);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./src/utils/formatters/CurrencyFormatter.ts
var CurrencyFormatter = __webpack_require__(23239);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/components/LoadingScreen.tsx + 1 modules
var LoadingScreen = __webpack_require__(91345);
// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/components/PayButton.hooks.ts
var PayButton_hooks = __webpack_require__(18211);
;// CONCATENATED MODULE: ./src/queries/order/queries/pendingPrescriptions.ts
/*
 * File: currentOrderWithPrescriptions.ts
 * Project: meki
 * File Created: Thursday, 15th July 2021 11:49:41 am
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Wednesday, 19th July 2023 1:10:36 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function pendingPrescriptions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query PendingPrescriptions {\n    pendingPrescriptions {\n      id\n      uuid\n      url\n      createdAt\n    }\n  }\n"
    ]);
    pendingPrescriptions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var pendingPrescriptions = function() {
    return (0,lib/* gql */.Ps)(pendingPrescriptions_templateObject());
};

// EXTERNAL MODULE: ./src/components/prescriptions/UploadImage.tsx + 2 modules
var UploadImage = __webpack_require__(99388);
// EXTERNAL MODULE: ./src/screens/checkout/components/BorderedContainer.tsx
var BorderedContainer = __webpack_require__(90403);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/components/PendingPrescriptions.styles.ts

var UploadImageContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "8px 16px 0px 16px",
    gap: "16px"
});

;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/components/PendingPrescriptions.tsx






function PendingPrescriptions(param) {
    var hasInsurance = param.hasInsurance, error = param.error, setError = param.setError;
    var ref = (0,useQuery/* useQuery */.a)(pendingPrescriptions(), {
        fetchPolicy: "cache-and-network"
    }), prescriptionsData = ref.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BorderedContainer/* BorderedContainer */.a, {
        title: "Recetas",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImageContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImage/* UploadImage */.z, {
                hasInsurance: hasInsurance,
                confirmText: true,
                emptyImagesError: error,
                setEmptyImagesError: setError,
                pendingPrescriptions: prescriptionsData === null || prescriptionsData === void 0 ? void 0 : prescriptionsData.pendingPrescriptions
            })
        })
    });
}

// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/zustand/localPaymentOptionsStore.tsx
var localPaymentOptionsStore = __webpack_require__(57500);
// EXTERNAL MODULE: ./src/screens/checkout/utils/getDeliveryCosts.ts
var getDeliveryCosts = __webpack_require__(4999);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/components/DeliveryDetails.styles.ts


var InformationContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    gap: "1px"
});
var InformationTypography = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        fontSize: "12px",
        fontWeight: 400,
        lineHeight: "18px",
        letterSpacing: "0.16px",
        color: theme.palette.text.secondary,
        "& > span": {
            fontWeight: 500,
            color: theme.palette.text.primary,
            marginRight: "5px"
        }
    };
});

// EXTERNAL MODULE: ./node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(64529);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/zustand/currentOrderStore.tsx

var currentOrderLoadingStore = (0,esm/* create */.Ue)()(function(set) {
    return {
        loadingCurrentOrder: false,
        setLoadingCurrentOrder: function(to) {
            set({
                loadingCurrentOrder: to
            });
        }
    };
});
var useCurrentOrderLoadingStore = function() {
    return currentOrderLoadingStore(function(state) {
        return {
            loadingCurrentOrder: state.loadingCurrentOrder,
            setLoadingCurrentOrder: state.setLoadingCurrentOrder
        };
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(91655);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/components/DeliveryDetails.tsx







function DeliveryDetails(props) {
    var ref;
    var deliveryDatesAndProductsAmount = props.deliveryDatesAndProductsAmount, address = props.address, deliveryType = props.deliveryType;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var loadingCurrentOrder = useCurrentOrderLoadingStore().loadingCurrentOrder;
    var firstDate = (ref = (deliveryDatesAndProductsAmount || [])[0]) === null || ref === void 0 ? void 0 : ref.date.replace(/-/g, "/");
    var title = deliveryType == "PICK_UP" ? "Detalle retiro" : "Detalle entrega";
    if (loadingCurrentOrder) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BorderedContainer/* BorderedContainer */.a, {
            title: title,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BorderedContainer/* ContentContainer */.O, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        height: 18,
                        width: 150
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            height: "1px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        height: 18,
                        width: 300
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BorderedContainer/* BorderedContainer */.a, {
        title: title,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BorderedContainer/* ContentContainer */.O, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationContainer, {
                children: [
                    (deliveryDatesAndProductsAmount === null || deliveryDatesAndProductsAmount === void 0 ? void 0 : deliveryDatesAndProductsAmount.length) == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationTypography, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: deliveryType == "PICK_UP" ? "Retiro:" : "Entrega:"
                            }),
                            (0,utils/* getWeekdayName */.ng)(firstDate),
                            " ",
                            (0,utils/* extractShortDate */.Pb)((0,utils/* withoutTimezone */.ej)(new Date(firstDate)))
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationTypography, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: deliveryType == "PICK_UP" ? "Retiros" : "Entregas"
                                })
                            }),
                            deliveryDatesAndProductsAmount === null || deliveryDatesAndProductsAmount === void 0 ? void 0 : deliveryDatesAndProductsAmount.map(function(values, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationTypography, {
                                    children: [
                                        "\xb7 ",
                                        values.productAmount,
                                        " producto",
                                        values.productAmount > 1 && "s",
                                        " el",
                                        " ".concat((0,utils/* getWeekdayName */.ng)(values.date.replace(/-/g, "/")), " ").concat((0,utils/* extractShortDate */.Pb)((0,utils/* withoutTimezone */.ej)(new Date(values.date.replace(/-/g, "/")))))
                                    ]
                                }, index);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationTypography, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Direcci\xf3n:"
                            }),
                            deliveryType == "PICK_UP" || isLocalVendor ? "Av. El Salto 4001, Local 8, Huechuraba" : (0,utils/* formatAddress */.Tg)(address)
                        ]
                    }),
                    deliveryType == "PICK_UP" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationTypography, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Horario de atenci\xf3n: "
                            }),
                            "Lunes a Viernes de 09:00 a 18:00 hrs"
                        ]
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./src/screens/checkout/paymentConfirm/components/ErrorModal.tsx + 1 modules
var ErrorModal = __webpack_require__(70276);
// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/components/PaymentsOptions.styles.ts
var PaymentsOptions_styles = __webpack_require__(96966);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/components/PaymentMethodDetails.styles.ts

var PaymentMethodItem = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    cursor: "default",
    opacity: 1,
    padding: "16px",
    gap: "8px"
});

// EXTERNAL MODULE: ./src/screens/checkout/components/CardIcon.tsx
var CardIcon = __webpack_require__(55678);
// EXTERNAL MODULE: ./src/interfaces/index.ts + 2 modules
var interfaces = __webpack_require__(95790);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/helpers/PaymentMethodTexts.tsx

var PaymentMethodTexts = function(param) {
    var paymentMethod = param.paymentMethod, creditsUsed = param.creditsUsed;
    var ref, ref1;
    var cardInfo = (0,interfaces/* isPaymentMethodDataOneClick */.KR)(paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.data) ? "".concat(paymentMethod === null || paymentMethod === void 0 ? void 0 : (ref = paymentMethod.data) === null || ref === void 0 ? void 0 : ref.creditCardType, " ").concat(paymentMethod === null || paymentMethod === void 0 ? void 0 : (ref1 = paymentMethod.data) === null || ref1 === void 0 ? void 0 : ref1.last4CardDigits.toString().replace(/XXXXXXXXXXXX/g, "•••• ")) : "";
    switch(paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type){
        case "ONE_CLICK":
            return {
                title: cardInfo,
                description: "Webpay OneClick"
            };
        case "FINTOC":
            return {
                title: "Directo con tu banco",
                description: "sin salir de la p\xe1gina"
            };
        case "MEKI_CREDIT":
            return {
                title: "Cr\xe9ditos Meki",
                description: creditsUsed
            };
        case "BANCO_ESTADO":
            return {
                title: "Banco Estado",
                description: "Compraqu\xed"
            };
        case "INSURANCE":
            return {
                title: "Seguro",
                description: ""
            };
        default:
            return {
                title: "",
                description: ""
            };
    }
};

;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/components/PaymentMethodDetails.tsx








var paymentMethodTypes = {
    CASH: "Efectivo",
    CARD: "Tarjeta",
    TRANSFER: "Transferencia",
    CARD_CASH: "Tarjeta + Efectivo"
};
function PaymentMethodDetails(param) {
    var paymentMethod = param.paymentMethod, creditsUsed = param.creditsUsed, hideHeader = param.hideHeader, hideInstallments = param.hideInstallments;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var isAssistantUser = userCan("MANAGE_USER");
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var order = (0,useOrderState/* useOrderState */.h)().order;
    var paymentMethodText = PaymentMethodTexts({
        paymentMethod: paymentMethod,
        creditsUsed: creditsUsed
    });
    var orderInstallments = order === null || order === void 0 ? void 0 : (ref = order.metadata) === null || ref === void 0 ? void 0 : ref.installments;
    var localPaymentMethod = order === null || order === void 0 ? void 0 : (ref1 = order.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.localVendor) === null || ref2 === void 0 ? void 0 : ref2.paymentMethod;
    var assistantPaymentMethod = order === null || order === void 0 ? void 0 : (ref3 = order.metadata) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.assistantVendor) === null || ref4 === void 0 ? void 0 : ref4.paymentMethod;
    var isClient = !(isLocalVendor && localPaymentMethod) && !(isAssistantUser && assistantPaymentMethod);
    var title = !hideHeader ? "M\xe9todo de pago" : "";
    var paymentMethodOptionTitle = isClient ? paymentMethodText === null || paymentMethodText === void 0 ? void 0 : paymentMethodText.title : isLocalVendor ? "Venta en local" : isAssistantUser ? "Pago por asistente" : "";
    var paymentMethodOptionDescription = isClient ? paymentMethodText === null || paymentMethodText === void 0 ? void 0 : paymentMethodText.description : isLocalVendor ? paymentMethodTypes[localPaymentMethod] : isAssistantUser ? paymentMethodTypes[assistantPaymentMethod] : "";
    var paymentMethodType = (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) === "FINTOC" ? "Fintoc" : (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) === "BANCO_ESTADO" ? "BancoEstado" : paymentMethod === null || paymentMethod === void 0 ? void 0 : (ref5 = paymentMethod.data) === null || ref5 === void 0 ? void 0 : ref5.creditCardType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BorderedContainer/* BorderedContainer */.a, {
        title: title,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentMethodItem, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardIcon/* CardIcon */._, {
                    creditCardType: paymentMethodType
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* TextDiv */.rk, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* OptionTitleText */.I3, {
                            children: paymentMethodOptionTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* OptionDescriptionText */.ex, {
                            light: true,
                            children: paymentMethodOptionDescription
                        }),
                        !hideInstallments && orderInstallments > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* InstallmentsText */.PM, {
                            children: [
                                orderInstallments,
                                " cuotas"
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/screens/checkout/paymentConfirm/components/ProductsList.tsx + 1 modules
var ProductsList = __webpack_require__(97441);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/styles.ts


var PaymentConfirmMainCard = (0,styled/* default */.Z)("div")({
    width: "100%",
    height: "100%",
    backgroundColor: "white",
    borderRadius: "12px",
    padding: "12px"
});
var EmailNotificationTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontSize: "12px",
    fontWeight: 400,
    color: "#2196F3",
    lineHeight: "24px",
    textAlign: "left",
    margin: "12px 0px 0px 0px"
});
var ErrorNotificationTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontSize: "12px",
    fontWeight: 400,
    color: "#F44336",
    lineHeight: "24px",
    textAlign: "left",
    margin: "12px 0px 0px 0px"
});

// EXTERNAL MODULE: ./src/components/PageWrapper.tsx
var PageWrapper = __webpack_require__(73362);
// EXTERNAL MODULE: ./src/screens/checkout/styles.ts
var styles = __webpack_require__(58055);
// EXTERNAL MODULE: ./src/components/Header/SimpleHeader.tsx + 1 modules
var SimpleHeader = __webpack_require__(45629);
// EXTERNAL MODULE: ./src/hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(71096);
// EXTERNAL MODULE: ./src/screens/checkout/components/Title.tsx
var Title = __webpack_require__(79728);
// EXTERNAL MODULE: ./src/screens/checkout/components/OrderSummary.tsx
var OrderSummary = __webpack_require__(42737);
// EXTERNAL MODULE: ./src/components/FormComponents.ts
var FormComponents = __webpack_require__(61912);
// EXTERNAL MODULE: ./src/hooks/useEventTracking.tsx + 1 modules
var useEventTracking = __webpack_require__(66630);
// EXTERNAL MODULE: ./src/validators/Events/Screen.ts
var Screen = __webpack_require__(42101);
// EXTERNAL MODULE: ./src/validators/Events/Error.ts
var Events_Error = __webpack_require__(64785);
// EXTERNAL MODULE: ./src/validators/Events/Interaction.ts
var Interaction = __webpack_require__(22656);
// EXTERNAL MODULE: ./src/validators/Events/Automatic.ts
var Automatic = __webpack_require__(21963);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/index.tsx






















































function PaymentConfirmPage() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var router = (0,next_router.useRouter)();
    var ref10 = (0,useAuth/* useAuth */.a)(), user = ref10.appUser;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var isAssistantUser = userCan("MANAGE_USER");
    var track = (0,useEventTracking/* useEventTracking */.A)().track;
    var trackIssue = (0,openreplay/* useOpenReplayTracking */.WK)().trackIssue;
    var trackPayment = (0,PayButton_hooks/* useTrackPayment */.w)();
    var trackFBEvent = (0,useFacebookPixel/* useFacebokPixelEvent */.o)().trackFBEvent;
    var isDesktop = (0,useWindowSize/* useWindowSize */.i)().isDesktop;
    var ref11 = (0,useMekiState/* useMekiState */.c)(), setInsuranceId = ref11.setInsuranceId, setInsuranceRut = ref11.setInsuranceRut;
    var setLoadingCurrentOrder = useCurrentOrderLoadingStore().setLoadingCurrentOrder;
    var ref12 = (0,usePendingPrescriptions/* usePendingPrescriptions */.h)(), requirePrescriptions = ref12.requirePrescriptions, requirePrescriptionUpload = ref12.requirePrescriptionUpload, pendingPrescriptions = ref12.pendingPrescriptions, associatedPrescriptions = ref12.associatedPrescriptions;
    var ref13 = (0,useOrderState/* useOrderState */.h)(), currentOrder = ref13.order, orderUuid = ref13.orderUuid, refetchOrder = ref13.refetch, loadingCurrentOrder = ref13.loadingCurrentOrder;
    var ref14 = (0,react.useState)(false), payLoading = ref14[0], setPayLoading = ref14[1];
    var ref15 = (0,react.useState)(false), error = ref15[0], setError = ref15[1];
    var ref16 = (0,react.useState)(""), errorMessage = ref16[0], setErrorMessage = ref16[1];
    var ref17 = (0,react.useState)(true), registryError = ref17[0], setRegistryError = ref17[1];
    var ref18 = (0,react.useState)(false), prescriptionsError = ref18[0], setPrescriptionsError = ref18[1];
    var ref19 = (0,react.useState)(false), isFintocSuccess = ref19[0], setIsFintocSucess = ref19[1];
    var ref20 = (0,react.useState)(false), fintocError = ref20[0], setFintocError = ref20[1];
    var ref21 = (0,react.useState)(false), showCancelButton = ref21[0], setShowCancelButton = ref21[1];
    var ref22 = (0,react.useState)(false), notAllowedItemsError = ref22[0], setNotAllowedItemsError = ref22[1];
    var ref23 = (0,react.useState)(false), insuranceValidationError = ref23[0], setInsuranceValidationError = ref23[1];
    var closeFintocIntervalRef = (0,react.useRef)();
    void track(Screen/* ScreenEventType.ScreenCheckoutConfirmPaymentView */.O.ScreenCheckoutConfirmPaymentView);
    var data = (0,useQuery/* useQuery */.a)((0,queries_paymentMethod/* getCheckoutPaymentMethod */.k)(), {
        variables: {
            params: {
                orderUuid: orderUuid
            }
        }
    }).data;
    var ref24 = (0,useQuery/* useQuery */.a)((0,detail/* OrderDeliveryOptions */.J)(), {
        variables: {
            params: {
                orderUuid: orderUuid
            }
        },
        fetchPolicy: isLocalVendor ? "cache-only" : "cache-and-network"
    }), tmp = ref24.data, orderDeliveryOptions = (tmp === void 0 ? {} : tmp).orderDeliveryOptions;
    var deliveryOption = orderDeliveryOptions === null || orderDeliveryOptions === void 0 ? void 0 : orderDeliveryOptions.find(function(item) {
        return item.dates.length === ((currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.orderGroupId) ? 2 : 1);
    });
    var ordersByDelivery = deliveryOption === null || deliveryOption === void 0 ? void 0 : deliveryOption.orders;
    var ref25 = (0,react.useState)(ordersByDelivery), orders = ref25[0], setOrders = ref25[1];
    var ref26 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(SeparateOrderDetailsByInsurance()), 1), separateDetailsByInsurance = ref26[0];
    var ref27 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(PayOrder("payOrderSummary"), {
        refetchQueries: [
            {
                query: (0,nextOrders/* getNextOrders */.t)()
            },
            {
                query: (0,queries_previousOrders/* previousOrdersQuery */.Q)("pedidos"),
                variables: {
                    params: {
                        pageNumber: 0
                    }
                }
            },
            {
                query: (0,getLastOrdersPurchases/* lastPurchasesQuery */.W)()
            },
            {
                query: (0,currentUserCredits/* currentUserCredits */.B)()
            }, 
        ]
    }), 1), payOrder = ref27[0];
    var ref28 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(PayOrderFintoc()), 1), payOrderFintoc = ref28[0];
    var ref29 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CancelFintocPayment()), 1), cancelFintocPayment = ref29[0];
    var ref30 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CancelPayOrderLocal()), 1), cancelPayOrderLocal = ref30[0];
    var ref31 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ConfirmLocalPayment()), 1), confirmLocalPayment = ref31[0];
    var ref32 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(DeclarePayOrder()), 1), declarePayOrder = ref32[0];
    var ref33 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CancelBancoEstadoPayment()), 1), cancelBancoEstadoPayment = ref33[0];
    var ref34 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(BancoEstadoPayment()), 1), bancoEstadoPayment = ref34[0];
    var ref35 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(VerifyBancoEstadoJwt()), 1), verifyBancoEstadoJwt = ref35[0];
    var ref36 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)((0,finalSummary/* getFinalSummary */.y)()), 1), prefetchOrder = ref36[0];
    var ref37 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)((0,nextOrders/* getNextOrders */.t)()), 1), getNextOrdersQuery = ref37[0];
    var ref38 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)((0,queries_previousOrders/* previousOrdersQuery */.Q)("pedidos")), 1), previousOrders = ref38[0];
    var ref39 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)((0,getLastOrdersPurchases/* lastPurchasesQuery */.W)()), 1), lastPurchases = ref39[0];
    var ref40 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)((0,currentUserCredits/* currentUserCredits */.B)()), 1), currentUserCreditsQuery = ref40[0];
    var currentUserInfo = (data !== null && data !== void 0 ? data : {}).currentUserInfo;
    var orderMetadata = currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.metadata;
    var ref41;
    var chargeDeliveryCost = (ref41 = orderMetadata === null || orderMetadata === void 0 ? void 0 : orderMetadata.chargeDeliveryCost) !== null && ref41 !== void 0 ? ref41 : true;
    var useMekiCredits = orderMetadata === null || orderMetadata === void 0 ? void 0 : orderMetadata.useMekiCredits;
    var insuranceInfo = orderMetadata === null || orderMetadata === void 0 ? void 0 : orderMetadata.insuranceInfo;
    var ordersTotal = orders === null || orders === void 0 ? void 0 : orders.reduce(function(acc, order) {
        var orderTotal = order.orderDetails.reduce(function(acc, detail) {
            return acc + detail.quantity * detail.price;
        }, 0);
        if (!chargeDeliveryCost && isAssistantUser) {
            return acc + orderTotal;
        }
        return acc + orderTotal + order.deliveryCost;
    }, 0);
    var paymentMethod = currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.paymentMethod;
    var ref42 = !chargeDeliveryCost && isAssistantUser || !deliveryOption ? {
        deliveryCost: 0,
        oldDeliveryCost: 0
    } : (0,getDeliveryCosts/* getDeliveryCosts */.U)(deliveryOption), deliveryCost = ref42.deliveryCost, oldDeliveryCost = ref42.oldDeliveryCost;
    // payAmount (to sent to payOrder) does not consider credits
    var payAmount = (insuranceInfo === null || insuranceInfo === void 0 ? void 0 : insuranceInfo.insuranceId) ? ordersTotal - ((insuranceInfo === null || insuranceInfo === void 0 ? void 0 : insuranceInfo.totalReimbursement) || 0) : ordersTotal;
    var needPrescriptions = (orders === null || orders === void 0 ? void 0 : orders.some(function(order) {
        return order.orderDetails.some(function(detail) {
            return [
                "NOT_REQUIRED",
                "SIMPLE",
                "HELD",
                "CHECK"
            ].includes(detail.product.prescriptionType);
        });
    })) || (insuranceInfo === null || insuranceInfo === void 0 ? void 0 : insuranceInfo.insuranceId);
    var ordersPayload = (0,react.useMemo)(function() {
        var usedStock = {};
        return ordersByDelivery === null || ordersByDelivery === void 0 ? void 0 : ordersByDelivery.map(function(order) {
            var ref, ref1, ref2;
            var cleanReimbursedProducts = currentOrder === null || currentOrder === void 0 ? void 0 : (ref = currentOrder.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.insuranceInfo) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.reimbursedProducts) === null || ref2 === void 0 ? void 0 : ref2.map(function(product) {
                return {
                    sku: +product.sku,
                    observation: product.observation,
                    unitReimbursement: product.unitReimbursement,
                    unitDeductible: product.unitDeductible,
                    unitCopay: product.unitCopay,
                    coverage: product.coverage,
                    quantity: product.quantity
                };
            });
            var _deliveryDate;
            return {
                deliveryDate: (_deliveryDate = order.deliveryDate) !== null && _deliveryDate !== void 0 ? _deliveryDate : "",
                reimbursedProductsInfo: cleanReimbursedProducts,
                details: order.orderDetails.map(function(detail) {
                    var _id;
                    usedStock[detail.product.id] = ((_id = usedStock[detail.product.id]) !== null && _id !== void 0 ? _id : 0) + detail.quantity;
                    var _statusWithoutStock, _price;
                    return {
                        availability: usedStock[detail.product.id] > detail.product.availability.stock ? (_statusWithoutStock = detail.product.availability.statusWithoutStock) !== null && _statusWithoutStock !== void 0 ? _statusWithoutStock : detail.product.availability.status : detail.product.availability.status,
                        price: (_price = detail.price) !== null && _price !== void 0 ? _price : 0,
                        productId: detail.product.id,
                        quantity: detail.quantity
                    };
                })
            };
        }).filter(function(e) {
            return e.details.length > 0;
        });
    }, [
        ordersByDelivery,
        currentOrder === null || currentOrder === void 0 ? void 0 : (ref = currentOrder.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.insuranceInfo) === null || ref1 === void 0 ? void 0 : ref1.reimbursedProducts, 
    ]);
    var handleHideError = function() {
        setError(false);
    };
    var handlePayment = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, ref2, ref3, _data, _payOrderFintoc, fintocToken, orderGroupId, uuid, Fintoc, options, widget, ref4, ref5, ref6, _data1, urlCompraqui, ref7, ref8, _data2, _payOrder, orderGroupId1, uuid1, orderOrGroupUuid, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        9,
                        ,
                        10
                    ]);
                    if (!orderDeliveryOptions) return [
                        2
                    ];
                    if (!((paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) == "FINTOC")) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        payOrderFintoc({
                            variables: {
                                params: {
                                    orderUuid: orderUuid,
                                    orders: ordersPayload,
                                    amount: payAmount,
                                    useCredits: useMekiCredits,
                                    insuranceId: (ref2 = orderMetadata === null || orderMetadata === void 0 ? void 0 : (ref1 = orderMetadata.insuranceInfo) === null || ref1 === void 0 ? void 0 : ref1.insuranceId) !== null && ref2 !== void 0 ? ref2 : null
                                }
                            }
                        }).catch(function(e) {
                            setPayLoading(false);
                            throw e;
                        })
                    ];
                case 1:
                    ref3 = _state.sent(), _data = ref3.data, _payOrderFintoc = _data.payOrderFintoc, fintocToken = _payOrderFintoc.fintocToken, orderGroupId = _payOrderFintoc.orderGroupId, uuid = _payOrderFintoc.uuid;
                    return [
                        4,
                        getFintoc()
                    ];
                case 2:
                    Fintoc = _state.sent();
                    options = {
                        widgetToken: fintocToken,
                        holderType: "individual",
                        product: "payments",
                        publicKey: environment/* FINTOC_TOKEN */.$F,
                        webhookUrl: environment/* GRAPHQL_URI */.r8 + environment/* MEKI_FINTOC_WEEBHOOK */.YU,
                        country: "cl",
                        onEvent: function(event) {
                            utils/* Console.log */.Mn.log("[FINTOC EVENT]: ", event);
                        // track(`fintoc event ${event}` as 'fintoc event', {
                        //   userId: user?.id,
                        // });
                        },
                        onSuccess: function() {
                            utils/* Console.error */.Mn.error("fintoc success");
                            // void track('fintoc success', {
                            //   userId: user?.id,
                            //   orderId: currentOrder?.id,
                            // });
                            track(Automatic/* AutomaticEventTypes.PaymentSuccess */.j5.PaymentSuccess, {
                                payment_method_type: paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type
                            });
                            setIsFintocSucess(true);
                            setShowCancelButton(false);
                            var interval = setInterval(function() {
                                void prefetchOrder({
                                    variables: {
                                        params: {
                                            status: [
                                                "PAYMENT_CONFIRMED",
                                                "DRAFT"
                                            ],
                                            uuid: orderGroupId !== null && orderGroupId !== void 0 ? orderGroupId : uuid
                                        }
                                    }
                                }).then(function(response) {
                                    if (response.data) {
                                        var ref, ref1;
                                        var status = response.data.ordersByUuid[0].status;
                                        var cancelledByFintoc = (ref = response.data.ordersByUuid[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : ref1.cancelledByFintoc;
                                        if (status === "PAYMENT_CONFIRMED") {
                                            clearInterval(interval);
                                            clearInterval(closeFintocIntervalRef.current);
                                            closeFintocIntervalRef.current = null;
                                            var _orderGroupId;
                                            var orderOrGroupUuid = (_orderGroupId = response.data.ordersByUuid[0].orderGroupId) !== null && _orderGroupId !== void 0 ? _orderGroupId : response.data.ordersByUuid[0].uuid;
                                            try {
                                                trackPayment({
                                                    orders: orders,
                                                    orderId: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
                                                    totalPrice: ordersTotal,
                                                    deliveryPrice: deliveryCost
                                                });
                                            } catch (e) {
                                                utils/* Console.error */.Mn.error("Error tracking payment");
                                                utils/* Console.error */.Mn.error(e);
                                            }
                                            try {
                                                trackFBEvent("track", "Purchase", {
                                                    currency: "CLP",
                                                    value: ordersTotal
                                                }, currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.uuid);
                                            } catch (e1) {
                                                utils/* Console.error */.Mn.error("Error tracking pixel payment");
                                                utils/* Console.error */.Mn.error(e1);
                                            }
                                            void getNextOrdersQuery();
                                            void previousOrders({
                                                variables: {
                                                    params: {
                                                        pageNumber: 0
                                                    }
                                                }
                                            });
                                            void lastPurchases();
                                            void currentUserCreditsQuery();
                                            track(Automatic/* AutomaticEventTypes.PaymentSuccess */.j5.PaymentSuccess, {
                                                payment_method_type: paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type
                                            });
                                            void router.push((0,utils/* getRoute */.Bv)("checkoutPaymentSuccess", {
                                                orderUuid: orderOrGroupUuid
                                            }));
                                            setPayLoading(false);
                                            return;
                                        } else if (status === "DRAFT" && cancelledByFintoc) {
                                            clearInterval(interval);
                                            if (closeFintocIntervalRef.current) {
                                                clearInterval(closeFintocIntervalRef.current);
                                                closeFintocIntervalRef.current = null;
                                            }
                                            setRegistryError(false);
                                            setError(true);
                                            setPayLoading(false);
                                        }
                                    }
                                }).catch(function() {
                                    utils/* Console.log */.Mn.log("ORDER NOT CONRFIRMED BY FINTOC");
                                });
                            }, 2000);
                            setInsuranceId(null);
                            setInsuranceRut("");
                            return;
                        },
                        onExit: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        setShowCancelButton(false);
                                        return [
                                            4,
                                            cancelFintocPayment({
                                                variables: {
                                                    params: {
                                                        orderUuid: orderUuid
                                                    }
                                                }
                                            }).catch(function(error) {
                                                utils/* Console.error */.Mn.error("fintoc cancel error");
                                                utils/* Console.error */.Mn.error(error);
                                                track(Events_Error/* ErrorEventTypes.PaymentCancel */.rf.PaymentCancel, {
                                                    type: "FINTOC",
                                                    error: error
                                                });
                                            })
                                        ];
                                    case 1:
                                        _state.sent();
                                        utils/* Console.error */.Mn.error("fintoc exit");
                                        // void track('fintoc exit', {
                                        //   orderId: currentOrder?.id,
                                        //   userId: user?.id,
                                        // });
                                        return [
                                            4,
                                            refetchOrder()
                                        ];
                                    case 2:
                                        _state.sent();
                                        setRegistryError(false);
                                        setError(true);
                                        setFintocError(true);
                                        setPayLoading(false);
                                        return [
                                            2
                                        ];
                                }
                            });
                        })
                    };
                    widget = Fintoc.create(options);
                    widget.open();
                    closeFintocIntervalRef.current = setInterval(function() {
                        void prefetchOrder({
                            variables: {
                                params: {
                                    status: [
                                        "DRAFT"
                                    ],
                                    uuid: orderGroupId !== null && orderGroupId !== void 0 ? orderGroupId : uuid
                                }
                            }
                        }).then(function(response) {
                            var ref, ref1;
                            var fintocPaymentIntentId = (ref = response.data.ordersByUuid[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : ref1.fintocPaymentIntentId;
                            if (!fintocPaymentIntentId) {
                                clearInterval(closeFintocIntervalRef.current);
                                closeFintocIntervalRef.current = null;
                                setRegistryError(false);
                                setError(true);
                                widget.destroy();
                            }
                        }).catch(function() {
                            utils/* Console.log */.Mn.log("ORDER NOT CANCELLED BY USER");
                        });
                    }, 2000);
                    return [
                        2
                    ];
                case 3:
                    if (!((paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) === "BANCO_ESTADO")) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        bancoEstadoPayment({
                            variables: {
                                params: {
                                    orderUuid: orderUuid,
                                    orders: ordersPayload,
                                    amount: payAmount,
                                    useCredits: useMekiCredits,
                                    insuranceId: (ref5 = orderMetadata === null || orderMetadata === void 0 ? void 0 : (ref4 = orderMetadata.insuranceInfo) === null || ref4 === void 0 ? void 0 : ref4.insuranceId) !== null && ref5 !== void 0 ? ref5 : null
                                }
                            }
                        }).catch(function(e) {
                            setPayLoading(false);
                            throw e;
                        })
                    ];
                case 4:
                    ref6 = _state.sent(), _data1 = ref6.data, urlCompraqui = _data1.bancoEstadoPayment.urlCompraqui;
                    void router.push(urlCompraqui);
                    return [
                        4,
                        refetchOrder()
                    ];
                case 5:
                    _state.sent();
                    setInsuranceId(null);
                    setInsuranceRut("");
                    return [
                        2,
                        ""
                    ];
                case 6:
                    return [
                        4,
                        payOrder({
                            variables: {
                                params: {
                                    orderUuid: orderUuid,
                                    orders: ordersPayload,
                                    amount: payAmount,
                                    useCredits: useMekiCredits,
                                    chargeDeliveryCost: chargeDeliveryCost !== null && chargeDeliveryCost !== void 0 ? chargeDeliveryCost : true,
                                    insuranceId: (ref7 = orderMetadata === null || orderMetadata === void 0 ? void 0 : (ref = orderMetadata.insuranceInfo) === null || ref === void 0 ? void 0 : ref.insuranceId) !== null && ref7 !== void 0 ? ref7 : null
                                }
                            }
                        }).catch(function(e) {
                            var err = e;
                            if ((0,errors/* isApolloError */.M)(err)) {
                                var isOrderWithNotAllowedProducts = err.graphQLErrors.some(function(error) {
                                    return error.message == "3005: Not all products are valid";
                                });
                                if (isOrderWithNotAllowedProducts) setNotAllowedItemsError(isOrderWithNotAllowedProducts);
                                if (err.message && err.message == "Insurance info does not match") {
                                    setInsuranceValidationError(true);
                                }
                            }
                            throw err;
                        })
                    ];
                case 7:
                    ref8 = _state.sent(), _data2 = ref8.data, _payOrder = _data2.payOrder, orderGroupId1 = _payOrder.orderGroupId, uuid1 = _payOrder.uuid;
                    track(Automatic/* AutomaticEventTypes.PaymentSuccess */.j5.PaymentSuccess, {
                        payment_method_type: paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type
                    });
                    try {
                        trackPayment({
                            orders: orders,
                            orderId: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
                            totalPrice: ordersTotal,
                            deliveryPrice: deliveryCost
                        });
                    } catch (e1) {
                        utils/* Console.error */.Mn.error("Error tracking payment");
                        utils/* Console.error */.Mn.error(e1);
                    }
                    try {
                        trackFBEvent("track", "Purchase", {
                            currency: "CLP",
                            value: ordersTotal
                        }, currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.uuid);
                    } catch (e2) {
                        utils/* Console.error */.Mn.error("Error tracking pixel payment");
                        utils/* Console.error */.Mn.error(e2);
                    }
                    return [
                        4,
                        prefetchOrder({
                            variables: {
                                params: {
                                    status: [
                                        "PAYMENT_CONFIRMED"
                                    ],
                                    uuid: orderGroupId1 !== null && orderGroupId1 !== void 0 ? orderGroupId1 : uuid1
                                }
                            }
                        }).finally(function() {
                            setPayLoading(false);
                        })
                    ];
                case 8:
                    _state.sent();
                    orderOrGroupUuid = orderGroupId1 !== null && orderGroupId1 !== void 0 ? orderGroupId1 : uuid1;
                    void router.push((0,utils/* getRoute */.Bv)("checkoutPaymentSuccess", {
                        orderUuid: orderOrGroupUuid
                    }));
                    return [
                        2,
                        ""
                    ];
                case 9:
                    e = _state.sent();
                    setPayLoading(false);
                    utils/* Console.error */.Mn.error("error", e);
                    setRegistryError(false);
                    setError(true);
                    return [
                        3,
                        10
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    }), [
        orderDeliveryOptions,
        paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type,
        payOrder,
        orderUuid,
        ordersPayload,
        payAmount,
        useMekiCredits,
        chargeDeliveryCost,
        orderMetadata === null || orderMetadata === void 0 ? void 0 : (ref2 = orderMetadata.insuranceInfo) === null || ref2 === void 0 ? void 0 : ref2.insuranceId,
        prefetchOrder,
        payOrderFintoc,
        track,
        user === null || user === void 0 ? void 0 : user.id,
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.uuid,
        setInsuranceId,
        setInsuranceRut,
        getNextOrdersQuery,
        previousOrders,
        lastPurchases,
        currentUserCreditsQuery,
        trackPayment,
        orders,
        ordersTotal,
        deliveryCost,
        trackFBEvent,
        cancelFintocPayment,
        refetchOrder,
        bancoEstadoPayment, 
    ]);
    var handlePaymentAction = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!paymentMethod) {
                        return [
                            2
                        ];
                    }
                    track(Interaction/* InteractionEventTypes.PaymentAttempt */.PA.PaymentAttempt, {
                        payment_method_type: paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type,
                        charge_delivery_cost: chargeDeliveryCost
                    });
                    return [
                        4,
                        handlePayment()
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        paymentMethod,
        track,
        user === null || user === void 0 ? void 0 : user.id,
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
        chargeDeliveryCost,
        handlePayment, 
    ]);
    var handleCancel = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!((currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.paymentMethod.id) === -6)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        cancelBancoEstadoPayment({
                            variables: {
                                params: {
                                    orderUuid: orderUuid
                                }
                            }
                        }).catch(function(error) {
                            utils/* Console.error */.Mn.error("Error cancel banco estado payment");
                            utils/* Console.error */.Mn.error(error);
                            track(Events_Error/* ErrorEventTypes.PaymentCancel */.rf.PaymentCancel, {
                                type: "BANCO_ESTADO",
                                error: error
                            });
                            return;
                        })
                    ];
                case 1:
                    _state.sent();
                    utils/* Console.error */.Mn.error("banco estado cancel");
                    track(Interaction/* InteractionEventTypes.PaymentCancel */.PA.PaymentCancel, {
                        payment_method_type: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.paymentMethod.type
                    });
                    return [
                        4,
                        refetchOrder()
                    ];
                case 2:
                    _state.sent();
                    setError(false);
                    setPayLoading(false);
                    return [
                        2
                    ];
                case 3:
                    return [
                        4,
                        cancelFintocPayment({
                            variables: {
                                params: {
                                    orderUuid: orderUuid
                                }
                            }
                        }).catch(function(error) {
                            utils/* Console.error */.Mn.error("Error cancel fintoc payment");
                            utils/* Console.error */.Mn.error(error);
                            track(Events_Error/* ErrorEventTypes.PaymentCancel */.rf.PaymentCancel, {
                                type: "FINTOC",
                                error: error
                            });
                        })
                    ];
                case 4:
                    _state.sent();
                    utils/* Console.error */.Mn.error("fintoc cancel");
                    track(Interaction/* InteractionEventTypes.PaymentCancel */.PA.PaymentCancel, {
                        payment_method_type: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.paymentMethod.type
                    });
                    return [
                        4,
                        refetchOrder()
                    ];
                case 5:
                    _state.sent();
                    setError(false);
                    setPayLoading(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        currentOrder === null || currentOrder === void 0 ? void 0 : (ref3 = currentOrder.paymentMethod) === null || ref3 === void 0 ? void 0 : ref3.id,
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
        cancelFintocPayment,
        orderUuid,
        track,
        user === null || user === void 0 ? void 0 : user.id,
        refetchOrder,
        cancelBancoEstadoPayment, 
    ]);
    var handleConfirmLocalPayment = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, _data, _confirmLocalPayment, orderGroupId, uuid, orderOrGroupUuid;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        confirmLocalPayment({
                            variables: {
                                params: {
                                    orderUuid: orderUuid
                                }
                            }
                        }).catch(function(e) {
                            setPayLoading(false);
                            throw e;
                        })
                    ];
                case 1:
                    ref = _state.sent(), _data = ref.data, _confirmLocalPayment = _data.confirmLocalPayment, orderGroupId = _confirmLocalPayment.orderGroupId, uuid = _confirmLocalPayment.uuid;
                    orderOrGroupUuid = orderGroupId !== null && orderGroupId !== void 0 ? orderGroupId : uuid;
                    try {
                        trackPayment({
                            orders: orders,
                            orderId: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
                            totalPrice: ordersTotal,
                            deliveryPrice: deliveryCost
                        });
                    } catch (e) {
                        setPayLoading(false);
                        utils/* Console.error */.Mn.error("Error tracking payment");
                        utils/* Console.error */.Mn.error(e);
                    }
                    try {
                        trackFBEvent("track", "Purchase", {
                            currency: "CLP",
                            value: ordersTotal
                        }, currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.uuid);
                    } catch (e1) {
                        setPayLoading(false);
                        utils/* Console.error */.Mn.error("Error tracking pixel payment");
                        utils/* Console.error */.Mn.error(e1);
                    }
                    void getNextOrdersQuery();
                    void previousOrders({
                        variables: {
                            params: {
                                pageNumber: 0
                            }
                        }
                    });
                    void lastPurchases();
                    void currentUserCreditsQuery();
                    setPayLoading(false);
                    void router.push((0,utils/* getRoute */.Bv)("checkoutPaymentSuccess", {
                        orderUuid: orderOrGroupUuid
                    }));
                    return [
                        2
                    ];
            }
        });
    }), [
        confirmLocalPayment,
        currentUserCreditsQuery,
        getNextOrdersQuery,
        lastPurchases,
        orders,
        orderUuid,
        previousOrders,
        trackPayment,
        trackFBEvent,
        ordersTotal,
        currentOrder,
        deliveryCost, 
    ]);
    var ref43 = (0,localPaymentOptionsStore/* useLocalPaymentOptionsActions */.e)(), cleanValuesLocal = ref43.cleanValues;
    var handleCancelPayOrderLocal = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    void cleanValuesLocal();
                    return [
                        4,
                        cancelPayOrderLocal({
                            variables: {
                                params: {
                                    orderUuid: orderUuid
                                }
                            }
                        }).catch(function(e) {
                            void trackIssue("[CANCEL_PAY_ORDER_LOCAL]: Error cancelling pay order local", {
                                orderUuid: orderUuid
                            });
                            track(Events_Error/* ErrorEventTypes.PaymentCancel */.rf.PaymentCancel, {
                                type: "LOCAL",
                                error: error
                            });
                            throw e;
                        }).finally(function() {
                            void router.push((0,utils/* getRoute */.Bv)("home"));
                        })
                    ];
                case 1:
                    _state.sent();
                    void router.push((0,utils/* getRoute */.Bv)("home"));
                    return [
                        2
                    ];
            }
        });
    }), [
        cancelPayOrderLocal,
        cleanValuesLocal,
        orderUuid,
        trackIssue
    ]);
    var handleAssistantPaymentAction = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, paymentOption, ref2, ref3, ref4, ref5, _data, _declarePayOrder, orderGroupId, uuid, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    paymentOption = currentOrder === null || currentOrder === void 0 ? void 0 : (ref = currentOrder.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.assistantVendor) === null || ref1 === void 0 ? void 0 : ref1.paymentMethod;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        ,
                        7
                    ]);
                    if (!paymentOption && !useMekiCredits) {
                        setPayLoading(false);
                        setErrorMessage("No se ha seleccionado un m\xe9todo de pago");
                        return [
                            2
                        ];
                    }
                    if (!(paymentOption === "CARD")) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        handlePaymentAction()
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
                case 3:
                    return [
                        4,
                        declarePayOrder({
                            variables: {
                                params: {
                                    orderUuid: orderUuid,
                                    orders: ordersPayload,
                                    amount: payAmount,
                                    sendEmail: (ref4 = currentOrder === null || currentOrder === void 0 ? void 0 : (ref2 = currentOrder.metadata) === null || ref2 === void 0 ? void 0 : ref2.sendEmail) !== null && ref4 !== void 0 ? ref4 : true,
                                    useCredits: useMekiCredits,
                                    paymentType: paymentOption,
                                    chargeDeliveryCost: chargeDeliveryCost,
                                    insuranceId: orderMetadata === null || orderMetadata === void 0 ? void 0 : (ref3 = orderMetadata.insuranceInfo) === null || ref3 === void 0 ? void 0 : ref3.insuranceId
                                }
                            }
                        })
                    ];
                case 4:
                    ref5 = _state.sent(), _data = ref5.data, _declarePayOrder = _data.declarePayOrder, orderGroupId = _declarePayOrder.orderGroupId, uuid = _declarePayOrder.uuid;
                    return [
                        4,
                        prefetchOrder({
                            variables: {
                                params: {
                                    status: [
                                        "PAYMENT_CONFIRMED"
                                    ],
                                    uuid: uuid
                                }
                            }
                        }).finally(function() {
                            setPayLoading(false);
                        })
                    ];
                case 5:
                    _state.sent();
                    void router.push((0,utils/* getRoute */.Bv)("checkoutPaymentSuccess", {
                        orderUuid: orderGroupId !== null && orderGroupId !== void 0 ? orderGroupId : uuid
                    }));
                    return [
                        3,
                        7
                    ];
                case 6:
                    e = _state.sent();
                    setError(true);
                    throw e;
                case 7:
                    return [
                        2
                    ];
            }
        });
    }), [
        currentOrder === null || currentOrder === void 0 ? void 0 : (ref4 = currentOrder.metadata) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.assistantVendor) === null || ref5 === void 0 ? void 0 : ref5.paymentMethod,
        currentOrder === null || currentOrder === void 0 ? void 0 : (ref6 = currentOrder.metadata) === null || ref6 === void 0 ? void 0 : ref6.sendEmail,
        useMekiCredits,
        declarePayOrder,
        orderUuid,
        ordersPayload,
        payAmount,
        chargeDeliveryCost,
        prefetchOrder,
        handlePaymentAction,
        orderMetadata === null || orderMetadata === void 0 ? void 0 : (ref7 = orderMetadata.insuranceInfo) === null || ref7 === void 0 ? void 0 : ref7.insuranceId, 
    ]);
    var prescriptionComponentRef = (0,react.useRef)(null);
    var scrollToDiv = function() {
        if (prescriptionComponentRef.current) {
            prescriptionComponentRef.current.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
        }
    };
    var prescriptionsValid = function() {
        var hasInsurance = Boolean(insuranceInfo === null || insuranceInfo === void 0 ? void 0 : insuranceInfo.claimId);
        var uploadedImages = (pendingPrescriptions === null || pendingPrescriptions === void 0 ? void 0 : pendingPrescriptions.length) > 0;
        if (hasInsurance && !uploadedImages && !associatedPrescriptions.length) return false;
        if (!requirePrescriptions) return true;
        if (!requirePrescriptionUpload) return true;
        return (pendingPrescriptions === null || pendingPrescriptions === void 0 ? void 0 : pendingPrescriptions.length) > 0 || associatedPrescriptions.length > 0;
    };
    var handleBack = (0,react.useCallback)(function() {
        if (requirePrescriptions) {
            void router.replace((0,utils/* getRoute */.Bv)("checkoutPrescriptions"));
            return;
        }
        void router.replace((0,utils/* getRoute */.Bv)("checkoutPaymentMethod"));
    }, [
        requirePrescriptions,
        router
    ]);
    var handlePay = (0,react.useCallback)(function() {
        setPayLoading(true);
        if (!prescriptionsValid()) {
            scrollToDiv();
            setPrescriptionsError(true);
            setPayLoading(false);
            return;
        }
        if (isLocalVendor) {
            void handleConfirmLocalPayment();
            return;
        }
        if (isAssistantUser) {
            void handleAssistantPaymentAction();
            return;
        }
        void handlePaymentAction();
        return;
    }, [
        requirePrescriptions,
        isLocalVendor,
        handleConfirmLocalPayment,
        handleAssistantPaymentAction,
        handlePaymentAction,
        prescriptionsValid,
        scrollToDiv, 
    ]);
    var ref44;
    var deliveryDatesAndProductsAmount = (ref44 = ordersPayload === null || ordersPayload === void 0 ? void 0 : ordersPayload.map(function(order) {
        return {
            date: order.deliveryDate,
            productAmount: order.details.length
        };
    })) !== null && ref44 !== void 0 ? ref44 : null;
    var currencyFormatter = new CurrencyFormatter/* CurrencyFormatter */.J({
        fallback: environment/* NEXT_PUBLIC_NO_PRICE_FALLBACK */.uh
    });
    (0,react.useEffect)(function() {
        if ((currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.status) === "PAYMENT_VALIDATION" && !isLocalVendor && !isAssistantUser) {
            setPayLoading(true);
            setIsFintocSucess(true);
            setShowCancelButton(true);
        }
        if ((currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.status) === "PAYMENT_VALIDATION" && isLocalVendor) {
            setPayLoading(false);
        }
        if ((currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.status) === "PAYMENT_VALIDATION" && isAssistantUser) {
            setPayLoading(false);
            setShowCancelButton(true);
        }
    }, [
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.status,
        isAssistantUser,
        isLocalVendor
    ]);
    (0,react.useEffect)(function() {
        var query = router.query;
        var jwt = query.jwt;
        if (jwt) {
            setPayLoading(true);
            void verifyBancoEstadoJwt({
                variables: {
                    params: {
                        jwt: jwt
                    }
                }
            }).then(function(response) {
                var ref;
                var ref1;
                var ref2 = (ref1 = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.verifyBancoEstadoJwt) !== null && ref1 !== void 0 ? ref1 : {}, orderUuid = ref2.uuid, orders = ref2.orders, totalPrice = ref2.totalPrice, deliveryPrice = ref2.deliveryPrice;
                if (orderUuid) {
                    // void track('banco estado success', {
                    //   userId: user?.id,
                    //   orderId: currentOrder?.id,
                    // });
                    track(Automatic/* AutomaticEventTypes.PaymentSuccess */.j5.PaymentSuccess, {
                        payment_method_type: paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type
                    });
                    try {
                        trackPayment({
                            orders: orders,
                            orderId: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
                            totalPrice: totalPrice,
                            deliveryPrice: deliveryPrice
                        });
                    } catch (e) {
                        utils/* Console.error */.Mn.error("Error tracking payment");
                        utils/* Console.error */.Mn.error(e);
                    }
                    try {
                        trackFBEvent("track", "Purchase", {
                            currency: "CLP",
                            value: ordersTotal
                        }, currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.uuid);
                    } catch (e1) {
                        utils/* Console.error */.Mn.error("Error tracking pixel payment");
                        utils/* Console.error */.Mn.error(e1);
                    }
                    void getNextOrdersQuery();
                    void previousOrders({
                        variables: {
                            params: {
                                pageNumber: 0
                            }
                        }
                    });
                    void lastPurchases();
                    void currentUserCreditsQuery();
                    void router.replace({
                        pathname: "/checkout/pago-exitoso/".concat(orderUuid),
                        query: (0,utils/* removeUndefineds */.ox)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                            orderUuid: orderUuid,
                            jwt: undefined
                        }))
                    });
                    return;
                }
                void router.replace({
                    pathname: "/checkout/confirmar-pago",
                    query: (0,utils/* removeUndefineds */.ox)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                        jwt: undefined
                    }))
                });
                setPayLoading(false);
                setRegistryError(false);
                setError(true);
            }).catch(function() {
                void router.replace({
                    pathname: "/checkout/confirmar-pago",
                    query: (0,utils/* removeUndefineds */.ox)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                        jwt: undefined
                    }))
                });
                setPayLoading(false);
                setRegistryError(false);
                setError(true);
            });
        }
    }, [
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.uuid,
        currentUserCreditsQuery,
        getNextOrdersQuery,
        lastPurchases,
        router,
        ordersTotal,
        previousOrders,
        track,
        trackFBEvent,
        trackPayment,
        user === null || user === void 0 ? void 0 : user.id,
        verifyBancoEstadoJwt, 
    ]);
    (0,react.useEffect)(function() {
        setLoadingCurrentOrder(loadingCurrentOrder);
    }, [
        loadingCurrentOrder,
        setLoadingCurrentOrder
    ]);
    var errorType = (0,react.useMemo)(function() {
        if (fintocError) return ErrorModal/* ErrorModalTypes.FINTOC */.C.FINTOC;
        if (registryError) return ErrorModal/* ErrorModalTypes.REGISTRY */.C.REGISTRY;
        if (notAllowedItemsError) return ErrorModal/* ErrorModalTypes.NOT_ALLOWED_ITEMS */.C.NOT_ALLOWED_ITEMS;
        if (insuranceValidationError) return ErrorModal/* ErrorModalTypes.INVALID_INSURANCE */.C.INVALID_INSURANCE;
        if (error) return ErrorModal/* ErrorModalTypes.DEFAULT */.C.DEFAULT;
        return ErrorModal/* ErrorModalTypes.NONE */.C.NONE;
    }, [
        fintocError,
        registryError,
        notAllowedItemsError,
        insuranceValidationError,
        error, 
    ]);
    (0,react.useEffect)(function() {
        var separateOrder = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, ref1, ref2, cleanReimbursedProducts, ref3, response;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            cleanReimbursedProducts = currentOrder === null || currentOrder === void 0 ? void 0 : (ref = currentOrder.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.insuranceInfo) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.reimbursedProducts) === null || ref2 === void 0 ? void 0 : ref2.filter(function(product) {
                                return product.coverage;
                            }).map(function(product) {
                                return {
                                    sku: +product.sku,
                                    observation: product.observation,
                                    unitReimbursement: product.unitReimbursement,
                                    unitDeductible: product.unitDeductible,
                                    unitCopay: product.unitCopay,
                                    quantity: product.quantity,
                                    coverage: product.coverage
                                };
                            });
                            if (!((ordersByDelivery === null || ordersByDelivery === void 0 ? void 0 : ordersByDelivery.length) && (cleanReimbursedProducts === null || cleanReimbursedProducts === void 0 ? void 0 : cleanReimbursedProducts.length))) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                separateDetailsByInsurance({
                                    variables: {
                                        params: {
                                            orders: ordersByDelivery,
                                            reimbursedProducts: cleanReimbursedProducts
                                        }
                                    }
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            setOrders((ref3 = response.data) === null || ref3 === void 0 ? void 0 : ref3.separateOrderDetailsByInsurance);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            setOrders(ordersByDelivery);
                            _state.label = 3;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function separateOrder() {
                return _ref.apply(this, arguments);
            };
        }();
        void separateOrder();
    }, [
        ordersByDelivery,
        currentOrder,
        separateDetailsByInsurance
    ]);
    if (payLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingScreen/* LoadingScreen */.a, {
            redirectMessage: (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) == "FINTOC" || (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) == "BANCO_ESTADO",
            isFintocSuccess: isFintocSuccess,
            showCancelButton: showCancelButton,
            handleCancel: handleCancel,
            isLocalVendor: isLocalVendor,
            isInsurance: (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) == "INSURANCE"
        });
    }
    var paymentMethodData = paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.data;
    var cardData = paymentMethodData && (paymentMethodData === null || paymentMethodData === void 0 ? void 0 : paymentMethodData.last4CardDigits) ? "".concat(paymentMethodData === null || paymentMethodData === void 0 ? void 0 : paymentMethodData.creditCardType, " ****").concat(paymentMethodData === null || paymentMethodData === void 0 ? void 0 : (ref8 = paymentMethodData.last4CardDigits) === null || ref8 === void 0 ? void 0 : ref8.toString().slice(-4)) : null;
    var title = isLocalVendor ? "Confirmaci\xf3n de compra" : "Confirma tu compra";
    var headerTitle = isDesktop || isLocalVendor ? null : "Confirma tu compra";
    var creditsUsed = useMekiCredits ? currencyFormatter.format(Math.min(currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.credits, ordersTotal)) : "$0";
    var buttonText = (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) == "ONE_CLICK" || isLocalVendor || isAssistantUser || (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) == "MEKI_CREDIT" || (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) == "INSURANCE" ? "Confirmar compra" : "Ir a pagar";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageWrapper/* BackgroundGlobalStyle */.m, {
                mobileColor: "gray"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleHeader/* SimpleHeader */.A, {
                title: headerTitle,
                homeButton: isDesktop,
                backButton: !isLocalVendor,
                handleBack: handleBack,
                color: "white"
            }),
            !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderSummary/* OrderSummary */.H, {
                variant: "simple",
                isDelivery: (currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.deliveryType) === "DELIVERY",
                deliveryCost: deliveryCost,
                oldDeliveryCost: oldDeliveryCost,
                handleNext: handlePay,
                loading: payLoading,
                buttonText: buttonText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageWrapper/* PageWrapper */.F, {
                addHeaderPadding: false,
                disableMobilePadding: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* HorizontalContainer */.bp, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* CheckoutCardsContainer */.Q9, {
                            desktopPadding: "16px",
                            children: [
                                isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* CheckoutTitle */.A, {
                                    title: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryDetails, {
                                    deliveryDatesAndProductsAmount: deliveryDatesAndProductsAmount,
                                    address: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.address,
                                    deliveryType: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.deliveryType
                                }),
                                isAssistantUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: (currentOrder === null || currentOrder === void 0 ? void 0 : (ref9 = currentOrder.metadata) === null || ref9 === void 0 ? void 0 : ref9.sendEmail) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmailNotificationTypography, {
                                        children: [
                                            "El cliente recibir\xe1 un correo",
                                            " "
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailNotificationTypography, {
                                        children: "El cliente no recibir\xe1 un correo"
                                    })
                                }),
                                isAssistantUser || isLocalVendor && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: errorMessage.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorNotificationTypography, {
                                        children: errorMessage
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsList/* ProductsList */.R, {
                                    isDelivery: (currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.deliveryType) === "DELIVERY",
                                    orders: orders,
                                    insuranceInfo: insuranceInfo
                                }),
                                !isLocalVendor && needPrescriptions && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PendingPrescriptions, {
                                            hasInsurance: Boolean(insuranceInfo === null || insuranceInfo === void 0 ? void 0 : insuranceInfo.claimId),
                                            error: prescriptionsError,
                                            setError: setPrescriptionsError
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            ref: prescriptionComponentRef
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethodDetails, {
                                    paymentMethod: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.paymentMethod,
                                    creditsUsed: creditsUsed
                                })
                            ]
                        }),
                        isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderSummary/* OrderSummary */.H, {
                            isDelivery: (currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.deliveryType) === "DELIVERY",
                            deliveryCost: deliveryCost,
                            oldDeliveryCost: oldDeliveryCost,
                            handleNext: handlePay,
                            cardData: cardData,
                            buttonText: buttonText,
                            loading: payLoading
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FormComponents/* SubmitButton */.Mm, {
                            disabled: payLoading,
                            onClick: handlePay,
                            children: buttonText
                        })
                    ]
                })
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorModal/* ErrorModal */.k, {
                handleHideError: handleHideError,
                uuid: orderUuid,
                errorType: errorType,
                refetchOrder: refetchOrder
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/checkout/confirmar-pago/index.tsx



function CheckoutPaymentConfirm() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* SEOHead */.R, {
                title: "Meki \xb7 Confirmar compra"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentConfirmPage, {})
        ]
    });
}


/***/ }),

/***/ 8002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gr": function() { return /* binding */ FREE_SECOND_SHIPPING_MIN_AMOUNT; },
/* harmony export */   "Nd": function() { return /* binding */ GOOGLE_RATING; },
/* harmony export */   "fI": function() { return /* binding */ DELIVERY_COST; },
/* harmony export */   "qM": function() { return /* binding */ SECOND_DELIVERY_COST; },
/* harmony export */   "yP": function() { return /* binding */ FREE_SHIPPING_MIN_AMOUNT; }
/* harmony export */ });
var FREE_SHIPPING_MIN_AMOUNT = 35000;
var FREE_SECOND_SHIPPING_MIN_AMOUNT = 70000;
var DELIVERY_COST = 3490;
var SECOND_DELIVERY_COST = 990;
var GOOGLE_RATING = 4.8;


/***/ }),

/***/ 66003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ getCheckoutPaymentMethod; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68921);
/*
 * File: summary.ts
 * Project: meki
 * File Created: Thursday, 11th November 2021 10:55:35 am
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Friday, 1st December 2023 11:26:34 am
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query getCheckoutPaymentMethod($params: CurrentOrderParams) {\n    currentOrder(params: $params) {\n      id\n      uuid\n      orderGroupId\n      deliveryCost\n      metadata {\n        useMekiCredits\n        installments\n        payments {\n          amount\n          type\n        }\n        userInfo {\n          email\n          name\n          rut\n        }\n        sendEmail\n        insuranceInfo {\n          insuranceId\n          totalReimbursement\n          totalDeductible\n          reimbursedProducts {\n            sku\n            observation\n            unitReimbursement\n            unitCopay\n            unitDeductible\n            coverage\n          }\n        }\n        localVendor {\n          paymentMethod\n          mixPayments\n        }\n        assistantVendor {\n          paymentMethod\n        }\n        chargeDeliveryCost\n      }\n      paymentMethod {\n        id\n        uuid\n        type\n        data\n      }\n      address {\n        id\n        name\n        street\n        streetNumber\n        commune\n      }\n    }\n    paymentMethods {\n      id\n      uuid\n      type\n      data\n    }\n    currentUserInfo {\n      credits\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var getCheckoutPaymentMethod = function() {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
};


/***/ }),

/***/ 29803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ lastPurchasesQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68921);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query lastOrdersPurchasesQuery {\n    lastOrdersPurchases {\n      product {\n        id\n        uuid\n        name\n        tradename\n        makerBrand\n        slug\n        concentration\n        imagesUrl\n        laboratory\n        activePrinciple\n        unit\n        quantity\n        thumbnailUrl\n        price\n        discount {\n          price\n          type\n          stockRestriction\n          dateRestriction\n          listPrice\n        }\n        prescriptionType\n        availability {\n          status\n          statusWithoutStock\n          stock\n          discountStock\n        }\n        categories {\n          id\n          name\n        }\n        isCheapestActivePrinciple\n      }\n      orderId\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var lastPurchasesQuery = function() {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
};


/***/ }),

/***/ 65165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ previousOrdersQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68921);
/*
 * File: previousOrders.ts
 * Project: meki
 * File Created: Tuesday, 16th November 2021 6:29:07 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Wednesday, 8th February 2023 4:04:29 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query ",
        "($params: GetOrdersParams) {\n    orders(params: $params) {\n      nodes {\n        id\n        uuid\n        orderGroupId\n        onDemand\n        address {\n          name\n          street\n          streetNumber\n        }\n        status\n        deliveryCost\n        deliveryDate\n        deliveryType\n        paidAt\n        payments {\n          id\n          amount\n          paymentMethodType\n          status\n        }\n        orderDetails(allowZero: true) {\n          id\n          uuid\n          price\n          quantity\n          requestedQuantity\n          returnedQuantity\n          product {\n            id\n            name\n            quantity\n            concentration\n          }\n        }\n        orderInsurance {\n          id\n        }\n      }\n      pageInfo {\n        hasNextPage\n        pageNumber\n        hasPreviousPage\n        totalPages\n      }\n      totalCount\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var previousOrdersQuery = function(name) {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject(), name);
};


/***/ }),

/***/ 93231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ currentUserCredits; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68921);
/*
 * File: currentUserInfo.tsx
 * Project: meki
 * File Created: Thursday, 7th January 2021 9:52:32 am
 * Author: Esperanza Horn (esperanza@inventures.cl)
 * -----
 * Last Modified: Monday, 6th March 2022 11:20:14 am
 * Modified By: Nicolás Castillo (nicolas.castillo@inventures.cl)
 * -----
 * Copyright 2020 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query currentUserCredits {\n    currentUserInfo {\n      id\n      credits\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var currentUserCredits = function() {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
};


/***/ }),

/***/ 90403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ ContentContainer; },
/* harmony export */   "a": function() { return /* binding */ BorderedContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47842);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_BaseStyles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8347);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91655);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44373);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13264);





var TitleContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "8px 16px"
    }, theme.breakpoints.down(450), {
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start"
    });
});
var BorderedContainerTitle = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.16px"
});
var BorderedContainerRightTitle = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return {
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "21px",
        letterSpacing: "0.16px",
        color: theme.palette.text.secondary
    };
});
var BorderedContainer = function(param) {
    var title = param.title, rightTitle = param.rightTitle, children = param.children, loading = param.loading, _rounded = param.rounded, rounded = _rounded === void 0 ? true : _rounded;
    if (loading) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_BaseStyles__WEBPACK_IMPORTED_MODULE_1__/* .MainCard */ .A, {
            rounded: rounded,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TitleContainer, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        variant: "rectangular",
                        width: "140px",
                        height: "24px"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
                children
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_BaseStyles__WEBPACK_IMPORTED_MODULE_1__/* .MainCard */ .A, {
        rounded: rounded,
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(TitleContainer, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BorderedContainerTitle, {
                                children: title
                            }),
                            rightTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BorderedContainerRightTitle, {
                                children: rightTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                ]
            }),
            children
        ]
    });
};
var ContentContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div")({
    padding: "8px 16px"
});


/***/ }),

/***/ 4999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ getDeliveryCosts; }
/* harmony export */ });
/* harmony import */ var _config_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8002);

function getDeliveryCosts(item) {
    var usedDeliveryCoupons = item.orders.filter(function(order) {
        return order.deliveryCoupon;
    }).length;
    var totalCost = item.orders[0].totalCost;
    var productsCost = totalCost - item.deliveryCost;
    var oldDeliveryCost = item.orders.length === 2 ? usedDeliveryCoupons === 2 ? _config_constants__WEBPACK_IMPORTED_MODULE_0__/* .DELIVERY_COST */ .fI + _config_constants__WEBPACK_IMPORTED_MODULE_0__/* .SECOND_DELIVERY_COST */ .qM : usedDeliveryCoupons === 1 ? productsCost < _config_constants__WEBPACK_IMPORTED_MODULE_0__/* .FREE_SHIPPING_MIN_AMOUNT */ .yP ? _config_constants__WEBPACK_IMPORTED_MODULE_0__/* .DELIVERY_COST */ .fI + _config_constants__WEBPACK_IMPORTED_MODULE_0__/* .SECOND_DELIVERY_COST */ .qM : productsCost < _config_constants__WEBPACK_IMPORTED_MODULE_0__/* .FREE_SECOND_SHIPPING_MIN_AMOUNT */ .Gr ? _config_constants__WEBPACK_IMPORTED_MODULE_0__/* .SECOND_DELIVERY_COST */ .qM : null : null : item.orders.length === 1 ? usedDeliveryCoupons === 1 ? productsCost < _config_constants__WEBPACK_IMPORTED_MODULE_0__/* .FREE_SHIPPING_MIN_AMOUNT */ .yP ? _config_constants__WEBPACK_IMPORTED_MODULE_0__/* .DELIVERY_COST */ .fI : null : null : null;
    return {
        oldDeliveryCost: oldDeliveryCost,
        deliveryCost: item.deliveryCost
    };
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8203,2962,2096,2510,1533,7284,5103,9388,4724,9774,2888,179], function() { return __webpack_exec__(54961), __webpack_exec__(32970); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);